var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.463 12.668a1 1 0 0 1-.07.08l-5.08 5.081a.75.75 0 1 1-1.061-1.06l5.08-5.081a1 1 0 0 1 .081-.07l-.386-.386-2.536-2.537a1.12 1.12 0 0 1-.331-.8c0-.266.092-.542.285-.753a4.6 4.6 0 0 1 3.593-1.516h.193a2.74 2.74 0 0 0 2.739-2.739v-.67c0-.304.119-.589.33-.8a1.143 1.143 0 0 1 1.608 0l5.68 5.68c.211.21.33.495.33.799 0 .625-.514 1.14-1.13 1.14h-.67a2.74 2.74 0 0 0-2.74 2.738v.212a5 5 0 0 1-1.47 3.528 1.143 1.143 0 0 1-1.608 0l-2.536-2.546zm-.486-5.544.03.002h.224a4.24 4.24 0 0 0 4.233-4.032L18.91 7.54a4.24 4.24 0 0 0-4.031 4.234v.212c0 .798-.28 1.574-.787 2.197l-2.266-2.273-.001-.002-1.737-1.737-2.276-2.275a3.1 3.1 0 0 1 2.165-.772",
    clipRule: "evenodd"
  })));
};
export { SvgPin as ReactComponent };